import { environment } from 'src/environments/environment';

export function error(msg: any, obj?: any, isTable?: boolean) {
	if (!!obj) {
		console.error(getMsg(msg, '😱🔥 👇'));
		if (Array.isArray(obj)) {
			console.table(obj);
		} else {
			if (!!isTable) {
				console.table(obj);
			} else {
				console.error(obj);
			}
		}
	} else {
		console.error(getMsg(msg, '😱🔥'));
	}
}

export function info(msg: any, obj?: any, isTable?: boolean) {
	if (environment.production) {
		return;
	}
	if (!!obj) {
		console.log(getMsg(msg, '👨‍🏫 👇'));
		if (Array.isArray(obj)) {
			console.table(obj);
		} else {
			if (!!isTable) {
				console.table(obj);
			} else {
				// tslint:disable-next-line: no-console
				console.info(obj);
			}
		}
	} else {
		// tslint:disable-next-line: no-console
		console.info(getMsg(msg, '👨‍🏫'));
	}
}

export function log(msg: any, obj?: any, isTable?: boolean) {
	if (environment.production) {
		return;
	}

	if (!!obj) {
		console.log(getMsg(msg, '✅ 👇'));
		if (Array.isArray(obj)) {
			console.table(obj);
		} else {
			if (!!isTable) {
				console.table(obj);
			} else {
				console.log(obj);
			}
		}
	} else {
		console.log(getMsg(msg, '✅'));
	}
}

/** obj parameter will be displayed using another call to console.warn */
export function warn(msg: any, obj?: any, isTable?: boolean) {
	if (!!obj) {
		console.warn(getMsg(msg, '☢️ 👇'));
		if (Array.isArray(obj)) {
			console.table(obj);
		} else {
			if (!!isTable) {
				console.table(obj);
			} else {
				console.warn(obj);
			}
		}
	} else {
		console.warn(getMsg(msg, '☢️'));
	}
}

function getMsg(msg: any, emoji: string): any {
	if (typeof msg === 'string') {

		return `${emoji} ${msg}`;
	}

	return msg;
}
